import queryString from "query-string"

export const getUrlVars = (searchLocation) => {
  // const vars = queryString.parse(searchLocation || window.location.search)
  // const output = {}
  //
  // for (const [key, val] of Object.entries(vars)) {
  //   output[key] = decodeURIComponent(val)
  // }

  // Object.keys(vars).forEach((k) => {
  //   output[k] = decodeURIComponent(vars[k])
  // })

  // return output
  return queryString.parse(searchLocation || window.location.search, {
    decode: true,
  })
}

/**
 *
 * @param {Record<string, string>} vars
 * @returns {string} Encoded URI string
 */
export const encodeQueryString = (vars) => {
  // const output = {}
  //
  // Object.keys(vars).forEach((k) => {
  //   output[k] = encodeURIComponent(vars[k])
  // })
  //
  // return `?${queryString.stringify(output)}`

  const encoded = queryString.stringify(vars)

  return `?${encoded}`
}
